var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_3016)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 34C78.1 34 79 34.9 79 36V52C79 53.1 78.1 54 77 54H43C41.9 54 41 53.1 41 52V36C41 34.9 41.9 34 43 34H77ZM77 30H43C39.69 30 37 32.69 37 36V52C37 55.31 39.69 58 43 58H77C80.31 58 83 55.31 83 52V36C83 32.69 80.31 30 77 30Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 66C78.1 66 79 66.9 79 68V84C79 85.1 78.1 86 77 86H43C41.9 86 41 85.1 41 84V68C41 66.9 41.9 66 43 66H77ZM77 62H43C39.69 62 37 64.69 37 68V84C37 87.31 39.69 90 43 90H77C80.31 90 83 87.31 83 84V68C83 64.69 80.31 62 77 62Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 38H50C48.8954 38 48 38.8954 48 40C48 41.1046 48.8954 42 50 42H52C53.1046 42 54 41.1046 54 40C54 38.8954 53.1046 38 52 38Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 38H59C57.8954 38 57 38.8954 57 40C57 41.1046 57.8954 42 59 42H61C62.1046 42 63 41.1046 63 40C63 38.8954 62.1046 38 61 38Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 38H68C66.8954 38 66 38.8954 66 40C66 41.1046 66.8954 42 68 42H70C71.1046 42 72 41.1046 72 40C72 38.8954 71.1046 38 70 38Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 46H50C48.8954 46 48 46.8954 48 48C48 49.1046 48.8954 50 50 50H52C53.1046 50 54 49.1046 54 48C54 46.8954 53.1046 46 52 46Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 46H59C57.8954 46 57 46.8954 57 48C57 49.1046 57.8954 50 59 50H61C62.1046 50 63 49.1046 63 48C63 46.8954 62.1046 46 61 46Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 46H68C66.8954 46 66 46.8954 66 48C66 49.1046 66.8954 50 68 50H70C71.1046 50 72 49.1046 72 48C72 46.8954 71.1046 46 70 46Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 70H50C48.8954 70 48 70.8954 48 72C48 73.1046 48.8954 74 50 74H52C53.1046 74 54 73.1046 54 72C54 70.8954 53.1046 70 52 70Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 70H59C57.8954 70 57 70.8954 57 72C57 73.1046 57.8954 74 59 74H61C62.1046 74 63 73.1046 63 72C63 70.8954 62.1046 70 61 70Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 70H68C66.8954 70 66 70.8954 66 72C66 73.1046 66.8954 74 68 74H70C71.1046 74 72 73.1046 72 72C72 70.8954 71.1046 70 70 70Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 78H50C48.8954 78 48 78.8954 48 80C48 81.1046 48.8954 82 50 82H52C53.1046 82 54 81.1046 54 80C54 78.8954 53.1046 78 52 78Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 78H59C57.8954 78 57 78.8954 57 80C57 81.1046 57.8954 82 59 82H61C62.1046 82 63 81.1046 63 80C63 78.8954 62.1046 78 61 78Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 78H68C66.8954 78 66 78.8954 66 80C66 81.1046 66.8954 82 68 82H70C71.1046 82 72 81.1046 72 80C72 78.8954 71.1046 78 70 78Z",
    fill: "#1A1B43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyModules);
export default __webpack_public_path__ + "static/media/icon-empty-modules.2fa6f02fc5be39aacab9033325eac875.svg";
export { ForwardRef as ReactComponent };